import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNewPassword } from '../store/api/CustomerApi';
import { useHistory } from 'react-router-dom'
import Loader from 'react-loader-spinner';

const RequestPassword = () => {
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    },[])
    const isLoading = useSelector(state => state.loading?.isLoading)
    const dispatch = useDispatch();
    const { register, errors, handleSubmit } = useForm();
    const history = useHistory();
    const onSubmit = (data) => {
        dispatch(
            setNewPassword(data, () => {
                localStorage.removeItem("token");
                history.push("/");
            })
        );
    }
    const checkPassword = (NewPass) => {
        const oldPass = document.getElementsByName("StringValue")[0].value;
            if(NewPass !== oldPass)
            {
                return false;
            }
            return true;

    }
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">تغییر رمز عبور</div>
                <div className="card-body bodyStyle">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                            <label>پسورد قبلی</label>
                            <input type="password" name="Name" className="form-control" ref={register({ required: true})} />
                            {errors.Name && <small className="errors">پسورد قبلی الزامی است</small>}
                        </div>
                        <div className="form-group">
                            <label>پسورد جدید</label>
                            <input type="password" name="StringValue" className="form-control" ref={register({ required: true })} />
                            {errors.StringValue && <small className="errors">پسورد جدید الزامی است</small>}
                        </div>
                        <div className="form-group">
                            <label>تکرار پسورد جدید</label>
                            <input type="password" name="NewPass" className="form-control" ref={register({ required: true, validate: checkPassword })} />
                            {errors.NewPass && <small className="errors">پسورد جدید با پسورد قبلی متفاوت است</small>}
                        </div>                        
                        {!isLoading ? <button className="btn btn-primary btn-block w-100 mt-2">تغییر رمز</button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="#bb1370" height={20} width={20} /> </span>}
                    </form>
                </div>
            </div>

        </div>

    );
}
export default RequestPassword;